export default "__VITE_ASSET__jKSc9VzF__"